import getConfig from 'next/config';

const { environment } = getConfig()?.publicRuntimeConfig || {};

export function isTestEnvironment(): boolean {
  return environment === 'test';
}
